import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import * as z from 'zod'

import { locationSchema } from './schemas/location'

const filterParamsSchema = z.object({
  location: locationSchema.schema.optional(),
})

export function useFilterValidation() {
  return useForm({
    resolver: zodResolver(filterParamsSchema),
    defaultValues: {
      location: locationSchema.defaultValues,
    },
  })
}
